module.exports = __webpack_public_path__ + "img/zoo.86d28b56.png";